module.exports = __webpack_public_path__ + "static/media/IMG_4412.e86fd2ac.jpg";